import { Component } from "@angular/core";
import { AnnotationsService } from "../../../services/annotations.service";
import { MainHeaderComponent } from "../../shared/main-header/main-header.component";
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from "@angular/forms";
import { MatInputModule } from "@angular/material/input";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatOptionModule } from "@angular/material/core";
import { MatIconModule } from "@angular/material/icon";
import { CommonModule, NgIf } from "@angular/common";
import { BehaviorSubject, combineLatest, concatMap, delay, EMPTY, filter, firstValueFrom, map, mergeMap, Observable, of, switchMap, take, tap, timeout } from "rxjs";
import { SearchAutocompleteComponent } from "../../shared/search-autocomplete/search-autocomplete.component";
import { Annotations } from "../../../models/annotations";
import { TableModule } from "primeng/table";
import { MatMenuModule, MatMenuTrigger } from "@angular/material/menu";
import { MatSelectModule } from "@angular/material/select";
import { MatButtonModule } from "@angular/material/button";
import { MatSnackBar } from "@angular/material/snack-bar";
import { AuthService } from "../../../services/auth.service";
import { ActivatedRoute, Router } from "@angular/router";
import { CvatTasksService } from "../../../services/cvat-tasks.service";
import { ModelsService } from "../../../services/models.service";


@Component({
  selector: "app-annotations",
  standalone: true,
  imports: [
    MainHeaderComponent,
    MatInputModule,
    MatFormFieldModule,
    FormsModule,
    ReactiveFormsModule,
    MatOptionModule,
    CommonModule,
    SearchAutocompleteComponent,
    TableModule,
    MatMenuTrigger,
    MatMenuModule,
    MatSelectModule,
    MatIconModule,
    MatButtonModule,
  ],
  templateUrl: "./annotations.component.html",
  styleUrl: "./annotations.component.scss",
})
export class AnnotationsComponent {
  selected_files: File[] = [];
  folder_name: string = "";
  csvFile: File[] = [];
  titleheader: string = " ";
  task_id!: number;
  fileDisplayText: string = '';
  project_id!: number;
  imageCount!: number;
  background_loader!: boolean
  creating: boolean = true; 
  jobs$!: Observable<any[]>;
  process_id: string = '';


  constructor(private annotationService: AnnotationsService, private cvatTaskService: CvatTasksService, private fb: FormBuilder, private modelsService: ModelsService, private _snackBar: MatSnackBar, private authService: AuthService, private route: ActivatedRoute, private router: Router) { }

  private default_annota: Partial<Annotations> = {
    models: []
  };

  private annotation_subject = new BehaviorSubject<Annotations | Partial<Annotations> | undefined>(this.default_annota);
  annotation$: Observable<Annotations | Partial<Annotations> | undefined> = this.annotation_subject.asObservable();

  // private task_subject = new BehaviorSubject<Annotations | Partial<Annotations> | undefined >(this.default_task);
  // task$: Observable<Annotations | Partial<Annotations> | undefined> = this.task_subject.asObservable();

  listModels$!: Observable<any>;

  formConfig = [
    {
      controlName: "name",
      label: "Nombre de la tarea",
      type: "text",
      width: "80%",
      margin: "",
    },
    {
      controlName: "segment_size",
      label: "Segmentación",
      type: "number",
      width: "15%",
      margin: "0 0 0 1rem",
    },
  ];


  AnnotationsForm: FormGroup = this.fb.group({
    name: ["", Validators.required],
    segment_size: [""],
  });
  
   ngOnInit() {
    this.listModels$ = this.modelsService.loadModelsStore().pipe(map((res: any) => res.data || []));
    this.project_id = +this.route.snapshot.paramMap.get('project_id')!;
    this.task_id = +this.route.snapshot.paramMap.get('task_id')!;
    console.log('Id de la tarea:', this.task_id);
    if(this.task_id) {
      this.creating = false;
      this.titleheader = 'Tarea con marcaciones';
      this.refreshAnnotations();
      this.jobs$ = this.cvatTaskService.getJobsByTaskId(this.task_id);
    } else {
      this.titleheader = 'Creando tarea con marcaciones';
    }
  }

  async loadFiles() {
    if (this.AnnotationsForm.invalid) {
      this._snackBar.open("Completa todos los campos requeridos", "Cerrar");
      return;
    }

    const models = this.buildPayloadFromModels();
    if (!models) {
      this._snackBar.open("No se han seleccionado modelos", "Cerrar");
      return;
    }

    const userData = await firstValueFrom(this.authService.getUserDataObservable().pipe(take(1)));
    if (!userData?.uid) {
      this._snackBar.open("No se pudo obtener el UID del usuario", "Cerrar");
      return;
    }
    
    this._snackBar.open("Por favor espera unos minutos...", "Cerrar", { duration: 3000 });
    this.background_loader = true

    if (this.csvFile.length > 0 && !this.imageProcessingDone.value) {
      this.processCSV();
    }

    if (this.selected_files.length > 0 && !this.imageProcessingDone.value) {
      await this.uploadAndSend();
    }
    
    const rawData = this.AnnotationsForm.value;
    const taskData = {
      name: rawData.name,
      segment_size: Number(rawData.segment_size),
      project_id: this.project_id,
    };
    console.log('cantidad de imagenes', this.imageCount)
    const body = { taskData, models, uid: userData.uid, folderName: this.folder_name , imageCount: this.imageCount};

    this.processAnnotations(body);

  }
  


  processAnnotations(body: any) {
    this.getImagesProcessed$().pipe(
      filter(ready => ready === true),
      take(1),
      switchMap(() => this.annotationService.initilizeProcess(body))
    ).subscribe({
      next: (response) => {
        this._snackBar.open("Proceso inicializado correctamente", "OK");
        console.log("Respuesta:", response);
        this.router.navigate(['/cvat','projects', this.project_id, 'tasks']);
        this.background_loader = false;
      },
      error: (err) => {
        this._snackBar.open("Error al iniciar el proceso", "Cerrar");
        console.error("Error en proceso:", err);
        this.background_loader = false
      }
    });
  }

refreshAnnotations() {
  combineLatest([
    this.cvatTaskService.getTasksDetails(this.task_id),
    this.cvatTaskService.getStates$(this.project_id),
    this.listModels$
  ])
    .pipe(
      map(([taskDetails, states, allModels]) => {
        const matchingState = states.find(state => +state.task_id === this.task_id);

        const firebaseModels = matchingState?.models || {}; 
        const process_id = matchingState?.process_id || '';
        this.process_id = process_id;
        console.log('process_id:', this.process_id);

        const fullModels = Object.values(firebaseModels)
          .map((modelId: any) => {
            const found = allModels.find((m: any) => m.model_id === modelId);
            return found ? { model_id: modelId, model: found } : null;
          })
          .filter(Boolean); 

        return {
          taskDetails,
          fullModels
        };
      })
    )
    .subscribe(({ taskDetails, fullModels }) => {
      this.AnnotationsForm.patchValue({
        name: taskDetails.name,
        segment_size: taskDetails.segment_size
      });

      this.annotation_subject.next({
        ...this.default_annota,
        models: fullModels
      });
    });
}
   onRetryProcess() {
    this.cvatTaskService.retryProcess(this.process_id).subscribe({
      next: () => {
        this._snackBar.open(`Proceso ${this.process_id} inicializado correctamente.`, 'ok', { duration: 3000 })
        // this.cvatService.loadTasksByProject(items.project_id)
      },
      error: (err: any) => {
        this._snackBar.open('No es posible reintentar proceso. Por favor crea una nueva anotación.', 'ok', { duration: 3000 })
      }
    })
  }

  onItemSelected(item: any): void {
    this.addModels(item);
  }

  addModels(item: any) {
    this.default_annota.models?.push({ model_id: item.model_id, model: item });
    this.annotation_subject.next(this.default_annota);
  }

  removeModel(model: any) {
    const index = this.default_annota.models?.findIndex(
      (m) => m.model.model_id === model.model.model_id
    );
    if (index !== undefined && index !== -1) {
      this.default_annota.models?.splice(index, 1);
      this.annotation_subject.next(this.default_annota); 
    }
  }



  // se construye el payload para enviar a reconocimiento las imagenes 
  //enviando dinamicamente los modelos
  buildPayloadFromModels(): any | null {
    const models = this.default_annota.models || [];

    if (models.length === 0) {
      console.warn("Selecciona al menos un modelo.");
      this._snackBar.open("Selecciona al menos un modelo.", "Ok");
      return null;
    }

    if (models.length > 5) {
      console.warn("Puedes seleccionar hasta 5 modelos.");
      this._snackBar.open("Puedes seleccionar hasta 5 modelos.", "Ok");
      return null;
    }

    const payload: any = {};

    models.forEach((model, index) => {
      payload[`model_${['one', 'two', 'three', 'four', 'five'][index]}`] = model.model_id;
    });

    return payload;
  }


  private imageProcessingDone = new BehaviorSubject<boolean>(false);

  setImagesProcessed(done: boolean) {
    this.imageProcessingDone.next(done);
  }

  getImagesProcessed$(): Observable<boolean> {
    return this.imageProcessingDone.asObservable();
  }


  eventCsv(event: Event) {
    const input = event.target as HTMLInputElement;
    if (!input.files?.length) return;

    const files = Array.from(input.files);
    this.csvFile = files
    this.selected_files = []
    this.fileDisplayText = files.map(f => f.name).join(', ');
  }


  // metodo para  validar que tenga las columnas requeridas y envia en csv al backend
  processCSV() {
    console.log('Procesando csv');

    if (!this.csvFile) {
      console.warn("No se ha seleccionado ningún archivo CSV.");
      return;
    }

    const column = 'urls';
    let validFilesCount = 0;
    const totalFiles = this.csvFile.length;

    for (const file of this.csvFile) {
      const reader = new FileReader();

      reader.onload = () => {
        const text = reader.result as string;
        const lines = text.split('\n');
        const imageCount = lines.length - 1;
        this.imageCount = imageCount;

        const headers = lines[0].split(',').map(h => h.trim().replace(/['"']+/g, ''));

        console.log(`Headers del archivo ${file.name}:`, headers);

        if (!headers.includes(column)) {
          alert(`El archivo "${file.name}" no contiene la columna requerida: "${column}"`);
          return;
        }

        validFilesCount++;

        if (validFilesCount === totalFiles) {
          const formData = new FormData();
          for (const f of this.csvFile) {
            formData.append('file', f);
          }

          console.log("csv en formdata:", formData);

          this.annotationService.sendCsv(formData).subscribe({
            next: () => {
              this.setImagesProcessed(true);
        
              console.log("CSV enviado a Python correctamente");
            },
            error: (e) => {
              this._snackBar.open('Ocurrió un error al cargar las imagenes', 'ok')
              console.error("Error al enviar el archivo CSV a Python", e),
              this.setImagesProcessed(false)
              this.background_loader = false
            }
          });
        }
      };

      reader.onerror = (error) => {
        console.error(`Error al leer el archivo ${file.name}:`, error);
      };

      reader.readAsText(file);
    }
  }



  eventImage(event: Event) {
    const input = event.target as HTMLInputElement;
    if (!input.files?.length) return;

    const files = Array.from(input.files);
    this.selected_files = files
    this.csvFile = [];

    this.fileDisplayText = `${files.length} imagen${files.length > 1 ? 'es' : ''} 
      cargada${files.length > 1 ? 's' : ''}`;

    this.folder_name = `carpeta${Date.now()}`;

    console.log("Imágenes detectadas. Carpeta:", this.folder_name);
  }


  // metodo para enviar imagenes por lotes en una misma carpeta
  // al cloud storage y enviar las  urls a la api de python
  uploadAndSend() {
    if (!this.selected_files.length) return;
    const batchSize = 20;
    const batches = [];
    const bucketName = 'cvat_pre_training'
    this.imageCount = this.selected_files.length;

    for (let i = 0; i < this.selected_files.length; i += batchSize) {
      batches.push(this.selected_files.slice(i, i + batchSize));
    }
    let completedUploads = 0;

    batches.forEach((batch) => {
      const formData = new FormData();
      formData.append("folder", this.folder_name);
      formData.append('bucketName', bucketName)

      for (const file of batch) {
        const path = (file as any).webkitRelativePath || file.name;
        formData.append("files", file, path);
      }
      this.annotationService.uploadImages(formData).subscribe({
        next: () => {
          completedUploads++;

          if (completedUploads === batches.length) {
            this.annotationService.sendUrlsBucket(this.folder_name, bucketName).subscribe({
              next: () => {
                console.log("URLs enviadas a Python correctamente")
                this.setImagesProcessed(true);
              },
              error: (e) => { 
                this._snackBar.open('Ocurrió un error al cargar las imagenes', 'ok')
                console.error("Error al enviar urls a python", e)
                this.background_loader = false
              }
            });
          }
        },
        error: (err) => {
          console.error("Error al subir la carpeta", err),
            this.setImagesProcessed(false);
        }
      });
    });
  }



}
